import { hasRole, type Role } from '@rp/contracts'

export const canReply = (role: Role): boolean => hasRole(role, 'reviewer')
export const canReclassify = (role: Role): boolean => hasRole(role, 'reviewer')
export const canRequestSuggestion = (role: Role): boolean => hasRole(role, 'reviewer')
export const canTakeOver = (role: Role): boolean => hasRole(role, 'approver')
export const canEndorse = (role: Role): boolean => hasRole(role, 'approver')
export const canReviewCorpus = (role: Role): boolean => hasRole(role, 'approver')
export const canManageKnowledge = (role: Role): boolean => hasRole(role, 'admin')
export const canManageSettings = (role: Role): boolean => hasRole(role, 'admin')
export const canManageChannels = (role: Role): boolean => hasRole(role, 'admin')
